import { render, staticRenderFns } from "./BLContainerDGPop.vue?vue&type=template&id=4c5e93b6"
import script from "./BLContainerDGPop.vue?vue&type=script&lang=js"
export * from "./BLContainerDGPop.vue?vue&type=script&lang=js"
import style0 from "./BLContainerDGPop.vue?vue&type=style&index=0&id=4c5e93b6&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5e93b6')) {
      api.createRecord('4c5e93b6', component.options)
    } else {
      api.reload('4c5e93b6', component.options)
    }
    module.hot.accept("./BLContainerDGPop.vue?vue&type=template&id=4c5e93b6", function () {
      api.rerender('4c5e93b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLContainerDGPop.vue"
export default component.exports